<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/device' }">Repossessed Device</el-breadcrumb-item>
                <el-breadcrumb-item>Manage Device</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :sm="24" :md="12" :lg="16">
                <div class="main-title">
                    Manage Device
                </div>

            </el-col>
            <el-col :sm="24" :md="12" :lg="8" class="text-right">
                <el-button type="default" size="small" @click="repairingDevice" v-loading="saving" v-if="device.state !== 'REPAIRING' && device.state !== 'OWNED'">Repairing</el-button>
                <el-button type="success" size="small" @click="refurbishedDevice" v-loading="saving" v-if="device.state !== 'REFURBISHED' && device.state !== 'OWNED'">Refurbished</el-button>
                <el-button type="warning" size="small" @click="assignDevice" v-loading="saving" v-if="device.state !== 'OWNED'">Assign</el-button>
            </el-col>
        </el-row>
        <el-card class="box-card mt-6" v-loading="loading">
            <div slot="header" class="clearfix">
                <span>Device Detail</span>
            </div>
            <div class="text item" >
                <el-table
                        :show-header="false"
                        :data="detailData"
                        style="width: 100%">
                    <el-table-column
                            label="key"
                            align="right"
                            class-name="font-bold">
                            <template slot-scope="scope" >
                                <span class="mr-6">{{scope.row.key}}</span>
                            </template>
                    </el-table-column>
                    <el-table-column
                            prop="value"
                            label="Value">
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <el-tabs class="mt-6">
            <!-- <el-tab-pane v-loading="loadingComments">
                <span slot="label"><strong>Comments</strong></span>
                <div class="container" style="margin-top: 12px">
                    
                    <el-card class="box-card" style="margin-top: 24px">
                        
                    </el-card>
                </div>
            </el-tab-pane> -->
            <el-tab-pane v-loading="loadingHistoryLogs">
                <span slot="label"><strong>History Logs</strong></span>
                <div  style="margin-top: 12px">
                    <el-card class="box-card" style="margin-top: 24px">
                        <el-table
                                :data="historyLogs">
                            <el-table-column
                                    property="fromState"
                                    label="Original State"
                                    width="150"/>
                            <el-table-column
                                    property="toState"
                                    label="To State"
                                    width="150"/>
                            <el-table-column
                                    property="comment"
                                    label="Comment"
                                    min-width="180"/>
                            <el-table-column
                                    property="author"
                                    label="Author"
                                    min-width="150" />
                            <el-table-column
                                    label="Timestamp"
                                    width="180">
                                    <template slot-scope="scope" >
                                        {{scope.row.timestamp | formatDate}}
                                    </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </el-tab-pane>
            <el-tab-pane v-loading="loadingOwnerships">
                <span slot="label"><strong>Device Ownerships</strong></span>
                <div style="margin-top: 12px">
                    <el-card class="box-card" style="margin-top: 24px">
                        <el-table
                                :data="deviceOwnerships">
                            <el-table-column
                                    property="id"
                                    label="Id"
                                    width="50"/>
                            <el-table-column
                                    property="contractNumber"
                                    label="Contract/Order No."
                                    width="180"/>
                            <el-table-column
                                    property="firstName"
                                    label="First Name"
                                    min-width="120"/>
                            <el-table-column
                                    property="lastName"
                                    label="lastName"
                                    width="150"/>
                            <el-table-column
                                    property="email"
                                    label="Email"
                                    min-width="180"/>
                            <el-table-column
                                    property="country"
                                    label="GSR Country"
                                    width="120"/>
                            <el-table-column
                                    property="userCountryName"
                                    label="user Country"
                                    width="120"/>
                            <el-table-column
                                    property="city"
                                    label="City"
                                    min-width="200"/>
                            <el-table-column
                                    property="mobileNumber"
                                    label="Mobile Number" 
                                    width="150"/>
                            <el-table-column
                                    property="state"
                                    label="Ownership State"
                                    width="180"/>
                            <el-table-column
                                    label="Last Updated"
                                    width="180">
                                    <template slot-scope="scope" >
                                        {{scope.row.lastModifiedDate | formatDateTime}}
                                    </template>
                            </el-table-column>
                            <!-- <el-table-column
                                    fixed="right"
                                    label="Operations"
                                    align="center"
                                    width="260">
                                <template slot-scope="scope">
                                    <el-button slot="reference" size="mini" type="danger" @click.stop="confirmRepossessDevice(scope.$index, scope.row)">Repossess</el-button>
                                    <el-button
                                        size="mini"
                                        @click="resetPassword(scope.$index, scope.row)">
                                        Reset Password
                                    </el-button>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </el-card>
                </div>
            </el-tab-pane>
        </el-tabs>
        <pair-device v-model="pairForm" v-on:submit-form="doPairDevice"/>
        <el-dialog :title="deviceStateChangeDialogTitle" :visible.sync="showDeviceStateChangeDialog" >
            <div v-loading="saving">
                <p style="word-break: normal">{{deviceStateChangeType}} Device with ID: <b>{{editingDevice.deviceID}}</b>?</p>
                <el-divider/>
                <el-form :model="editingDevice" ref="deviceForm" >

                    <el-form-item label="Comment" >
                        <el-input type="textarea" v-model="editingDevice.comment"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDeviceStateChangeDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="doEditDevice()">Submit</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import Pagination from "@/components/Pagination"
import _ from 'lodash'
import api from '@/services/api/WRCService'
import pairDevice from "@/components/PairDevice"
import moment from 'moment'

export default {
    props: ['deviceId'],
    components: { 
        Pagination,
        pairDevice
    },
    data: function() {
        return {
            saving: false,
            loading: false,
            loadingComments: false,
            loadingHistoryLogs: false,
            loadingOwnerships: false,
            detailData: [],
            historyLogs: [],
            deviceOwnerships: [],
            device: {},
            deviceStateChangeDialogTitle: '',
            showDeviceStateChangeDialog: false,
            deviceStateChangeType: '',
            editingDevice: {},
            deviceLogQuery: {
                total: 3,
                page: 1,
                limit: 100
            },
            deviceOwnersQuery: {
                total: 3,
                page: 1,
                limit: 100
            },
            pairForm: {
                show: false,
            }
        }
    },
    methods: {
        loadData() {
            this.loading = true

            api.getDevice(this.deviceId).then(({data}) =>{
                this.device = data.data

                this.detailData = [
                    { key: "Device ID", value: this.device.deviceID},
                    { key: "Status", value: this.device.state},
                    { key: "Registered Date", value: moment(this.device.createdDate).format('DD-MMM-YYYY')}
                ]
            }).catch(() => {}).then(() => {
                this.loading = false
            })

            this.loadDeviceHistoryLogs();
            this.loadDeviceOwnerships();
        },
        loadDeviceOwnerships() {
            this.loadingOwnerships = true;

            api.getDevicesOwners(this.deviceId, {
                page: this.deviceOwnersQuery.page - 1,
                size: this.deviceOwnersQuery.limit
            }).then(({ data }) => {

                this.deviceOwnerships.splice(0, this.deviceOwnerships.length);
                this.deviceOwnerships.push(...data.data.items);
                this.deviceOwnersQuery.total = data.data.pagination.totalRecords;

            }).catch(() => {}).then(() => {
                this.loadingOwnerships = false;
            });
        },
        loadDeviceHistoryLogs() {
            this.loadingHistoryLogs = true;

            api.getDeviceLogs(this.deviceId, {
                page: this.deviceLogQuery.page - 1,
                size: this.deviceLogQuery.limit
            }).then(({ data }) => {

                this.historyLogs.splice(0, this.historyLogs.length);
                this.historyLogs.push(...data.data.items);
                this.deviceLogQuery.total = data.data.pagination.totalRecords;

            }).catch(() => {}).then(() => {
                this.loadingHistoryLogs = false;
            });
        },
        refurbishedDevice() {
            this.editingDevice = {
                deviceID: this.device.deviceID,
                comment: ''
            }
            this.deviceStateChangeType = "Refurbish"
            this.deviceStateChangeDialogTitle = "Refurbish Device"
            this.showDeviceStateChangeDialog = true
        },
        repairingDevice() {
            this.editingDevice = {
                deviceID: this.device.deviceID,
                comment: ''
            }
            this.deviceStateChangeType = "Repairing"
            this.deviceStateChangeDialogTitle = "Repairing Device"
            this.showDeviceStateChangeDialog = true
        },
        doEditDevice() {
            if (this.deviceStateChangeType === "Refurbish") {
                this.doRefurbishedDevice()
            } else {
                this.doRepairingDevice()
            }
        },
        doRefurbishedDevice() {
            this.saving = true

            api.refurbishDevice(this.device.id, this.editingDevice.comment)
            .then(({ data }) => {

                this.$message({
                    message: 'Set device status as refurbished.',
                    type: 'success'
                });

                this.loadData()

                this.showDeviceStateChangeDialog = false

            }).catch(() => {

            }).then(() => {
                this.saving = false
            });
        },
        doRepairingDevice() {
            this.saving = true

            api.repairingDevice(this.device.id, this.editingDevice.comment)
            .then(({ data }) => {

                this.$message({
                    message: 'Set device status as repairing.',
                    type: 'success'
                });

                this.loadData()

                this.showDeviceStateChangeDialog = false

            }).catch(() => {

            }).then(() => {
                this.saving = false
            });
        },
        assignDevice() {
            this.pairForm = {
                show: true,
                deviceID: this.device.deviceID
            }
        },
        doPairDevice() {
            this.pairForm.show = false

            var param = {
                email: this.pairForm.email,
                parentModePasswordResetEmail: this.pairForm.resetEmail,
                deviceID: this.pairForm.deviceID,
                firstName: this.pairForm.firstName,
                lastName: this.pairForm.lastName,
                gsrCountryId: this.pairForm.country.id,
                retailCountryCode: this.pairForm.country.code,
                userCountryName: this.pairForm.userCountry.country,
                userCountryCode: this.pairForm.userCountry.abbreviation,
                city: this.pairForm.city,
                contactNumber: this.pairForm.mobileNo,
                contractNumber: this.pairForm.contractNumber,
                comment: this.pairForm.comment
            }

            this.loading = true

            api.pairDevice(param)
            .then(({ data }) => {

                this.$message({
                    message: 'Assigned device.',
                    type: 'success'
                });

                this.loadData()

            }).catch(() => {
                
            }).then(() => {
                this.loading = false
            });
        },
    },
    mounted() {
        if (!_.isUndefined(this.deviceId)) {
            this.loadData();
        }
    }
}
</script>
